// @flow
import * as React from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { clearForgotPasswordError } from '@redux/components/ForgotPassword/actions';
import { StyledButtonTransparentWhite } from '@styles/buttons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { withTranslation } from 'react-i18next';
import { useBreakpoint } from '@hooks';

import type { Props } from './types';

import LoginForm from '../LoginForm';
import ForgotPasswordForm from '../ForgotPasswordForm';

import { StyledButtonsContainer, StyledButtonLinkTransparentWhite, StyledFontAwesomeIcon } from '../LoginForm/styles';

import {
  StyledWrapper, ButtonBar
} from './styles';

const LoginContainer = ({
  t, curefyNavbar, clearForgotPasswordError, ...props
}: Props): React.Node => {
  const [form, setForm] = React.useState('none');

  const isMobile: boolean = useBreakpoint('mobile', 'desktop');

  const displayForm: string = form === 'none' && !isMobile ? 'login' : form;

  const toForgot = (): void => setForm('forgot');
  const toNone = (): void => setForm('none');

  const toLogin = (): void => {
    setForm('login');
  };

  const handleOutsideClick = (): void => {
    clearForgotPasswordError();
    toNone();
  };

  return (
    <OutsideClickHandler onOutsideClick={handleOutsideClick}>
      <StyledWrapper>
        {isMobile && (
          <ButtonBar>
            {displayForm !== 'none' && <StyledFontAwesomeIcon icon={faChevronLeft} onClick={toNone} />}
          </ButtonBar>
        )}

        {isMobile && displayForm === 'none' && (
          <StyledButtonsContainer>
            <StyledButtonTransparentWhite full onClick={toLogin} curefyNavbar={curefyNavbar}>
              {t('Login')}
            </StyledButtonTransparentWhite>

            <StyledButtonLinkTransparentWhite href={curefyNavbar ? '/opinion-flow' : '/online-consultation'}>
              {`${t('NotMember')} `}
              <span className="underline">{t('SignUpHere')}</span>
            </StyledButtonLinkTransparentWhite>
          </StyledButtonsContainer>
        )}

        {displayForm === 'login' && <LoginForm {...props} onForgotPassword={toForgot} />}

        {displayForm === 'forgot' && <ForgotPasswordForm {...props} onLogin={toLogin} />}
      </StyledWrapper>
    </OutsideClickHandler>
  );
};

const mapDispatchToProps = { clearForgotPasswordError };

export default compose(
  connect(
    null,
    mapDispatchToProps
  ),
  withTranslation('Login')
)(LoginContainer);
